import React, { memo, useEffect, useState } from "react";
import s from "./index.module.less";
import { connect } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { LlwAiAiShow, LlwAiMainPageClick, LlwAiMainPageShow } from "@/utils/sensorsFunc";
import { getUrlParams, checkLogin } from "@/utils/common";
import { getUserInfo } from "@/api/index";
import { REDRAW_MODE } from '@/views/AIEditV3/consts'
import homeActiveIcon from '@/assets/images/home/home-active.svg'

let clickedMenuItem = {};

/**
 * @description v3版本侧边栏
 */
const AppSideBar = (props) => {
    const {
        userInfo,
        updateAiSource,
        isMobileDevice,
        fromLiuYunKu,
        ai_source,
        setReDrawMode
    } = props;
    const location = useLocation();
    const menuItems = [
        {
            id: 'Home',
            path: '/pro/Home',
            label: '首页',
            defaultIconClass: 'icon-shouye-moren',
            activeIconClass: 'icon-shouye-xuanzhong',
            activeIcon: homeActiveIcon
        },
        {
            id: 'Index',
            path: '/pro/Index',
            label: 'AI生图',
            defaultIconClass: 'icon-shentu-moren',
            activeIconClass: 'icon-shengtu-xuanzhong'
        },
        {
            id: 'AIRender',
            path: '/pro/AIRender',
            label: 'AI渲染',
            defaultIconClass: 'icon-xuanran',
            activeIconClass: 'icon-xuanran_kuai'
        },
        {
            id: 'ChangePic',
            path: '/pro/ChangePic',
            label: 'AI改图',
            defaultIconClass: 'icon-aigaitumoren',
            activeIconClass: 'icon-aiIgaituxuanzhong'
        },
        {
            id: 'PlaneColoring',
            path: '/pro/PlaneColoring',
            label: '平面填彩',
            defaultIconClass: 'icon-a-caipingtu1',
            activeIconClass: 'icon-a-caipingtu2',
        },
        {
            id: 'AIPlanSpeculation',
            path: '/pro/AIPlanSpeculation',
            label: '方案推敲',
            defaultIconClass: 'icon-a-zuoce-fangantuiqiao1',
            activeIconClass: 'icon-a-zuoce-fangantuiqiao3',
            isNew2: true
        },
        // {
        //     id: 'Canvas',
        //     path: '/pro/Canvas',
        //     label: '画布',
        //     defaultIconClass: 'icon-huabu-moren',
        //     activeIconClass: 'icon-huabu-xuanzhong'
        // },
        // {
        //     id: 'Toolkit',
        //     path: '/pro/Toolkit',
        //     label: '工具集',
        //     defaultIconClass: 'icon-wanfa-moren',
        //     activeIconClass: 'icon-wanfa-xuanzhong',
        // },
        {
            id: 'WorkManagePage',
            path: '/pro/workManagePage',
            label: '作品',
            defaultIconClass: 'icon-zuopin-moren',
            activeIconClass: 'icon-zuopin-xuanzhong'
        },
        // {
        //     id: 'OldVersions',
        //     path: '/main/AIDraw',
        //     label: '旧版',
        //     defaultIconClass: 'icon-jiuban-moren',
        //     activeIconClass: 'icon-jiuban-xuanzhong',
        //     hidden: isMobileDevice? true : false
        // }
    ];
    const [hoverIndex, setHoverIndex] = useState(null)
    const [activeMenuItemKey, setActiveMenuItemKey] = useState('Home') // 激活菜单

    const navigate = useNavigate();
    const navigateToPage = () => {
        const { url, key } = clickedMenuItem;
        setActiveMenuItemKey(key);
        if(ai_source && ai_source != 4){
            // 返回首页保留来源
            navigate(url + '?ai_source=' + ai_source);
            return
        }
        navigate(url);
    }

    useEffect(() => {
        switch (location.pathname) {
            case "/pro/Home": {
                setActiveMenuItemKey('Home')
                break;
            }
            case "/pro/Index": {
                setActiveMenuItemKey('Index')
                break;
            }
            case "/pro/Canvas": {
                setActiveMenuItemKey('Canvas')
                break;
            }
            case "/pro/AIRender": {
                setActiveMenuItemKey('AIRender')
                break;
            }
            case "/pro/PlaneColoring": {
                setActiveMenuItemKey('PlaneColoring')
                break;
            }
            case "/pro/workManagePage": {
                setActiveMenuItemKey('WorkManagePage')
                break;
            }
            case "/pro/AIEditDetailEnhance": {
                setActiveMenuItemKey('')
                break;
            }
            case "/pro/Toolkit": {
                setActiveMenuItemKey('Toolkit')
                break;
            }
            // 2026-6-17 新增AI改图
            case "/pro/ChangePic": {
                setActiveMenuItemKey('ChangePic')
                break;
            }
            case "/pro/AIPlanSpeculation": {
                setActiveMenuItemKey('AIPlanSpeculation')
                break;
            }
            default: {
                setActiveMenuItemKey('Home')
                break;
            }
        }
    },[location])

    // LlwAiMainPageShow上报
    const LlwAiMainPageShowReport = () => {
        // 确保用户在埋点前注册，强制重新调用一次
        getUserInfo().then(() => {
          LlwAiMainPageShow({
            main_page_show: '6',
            change_tfunction: 1
          })
        })
    }

    const handleMenuItemClick = async (url, key) => {
        // AI改图 点击新开浏览器标签页
        if (url === '/pro/ChangePic') {
            const openUrl = `${window.location.origin}/#${url}` + (ai_source && ai_source != 4 ? `?ai_source=${ai_source}` : '')
            window.open(openUrl, '_blank')
            return
        }
        if (activeMenuItemKey === key) return;
        clickedMenuItem = { url, key };
        document.title = '溜溜AI-支持在线协作的AI创作社区'
        if (url === '/pro/AIEditDetailEnhance') {
            LlwAiMainPageClick({
                main_page_click: '6'
            })
        }
        if (url === '/pro/Canvas') {
            LlwAiMainPageShowReport()
            setReDrawMode(REDRAW_MODE.DRAW)
        }
        if(url === '/pro/AIRender'){
            LlwAiMainPageClick({
                main_page_click: '25'
            })
            setReDrawMode(REDRAW_MODE.RENDER)
        }
        if(url === '/pro/PlaneColoring'){
            LlwAiMainPageClick({
                main_page_click: '26'
            })
            setReDrawMode(REDRAW_MODE.FLAT)
        }
        if(url === '/pro/AIPlanSpeculation'){
            LlwAiMainPageClick({
                main_page_click: '28'
            })
            setReDrawMode(REDRAW_MODE.SPECULATION)
        }
        navigateToPage();
    };


    return (
        <>
            <div className={s.appSideBarWrap}>
                <div className={s.menuNavWrap}>
                {menuItems.map((item, index) => (
                    !item.hidden && (
                    <div key={item.id} className={`${s.menuNavItem} ${activeMenuItemKey === item.id ? s.active : ''}`}
                    onClick={() => handleMenuItemClick(item.path, item.id)}
                    onMouseEnter={() => setHoverIndex(index)} onMouseLeave={() => setHoverIndex(null)}>
                        <i className={`iconfont ${(activeMenuItemKey === item.id || hoverIndex === index) ? item.activeIconClass : item.defaultIconClass }`}/>
                        <span>{item.label}</span>
                        {item.isNew && <div className="newTag">Banana</div>}
                        {item.isNew2 && <div className="newTag">New</div>}
                    </div>
                    )
                ))}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = ({ app }) => {
    return {
        userInfo: app.userInfo,
        isMobileDevice: app.isMobileDevice,
        fromLiuYunKu: [6, 7, 10, 11, 12].includes(+app.ai_source), // 是否在溜云库中打开
        ai_source: app.ai_source
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAiSource: (params) => {
            return dispatch({
                type: "app/updateAiSource",
                payload: params
            });
        },
        setReDrawMode: (params) => {
            return dispatch({
              type: 'edit/setReDrawMode',
              payload: params,
            })
          },
    };
};
export default memo(connect(mapStateToProps, mapDispatchToProps)(AppSideBar));
